export default function useEventStopPropagation(fn) {
    if (!fn)
        return undefined;
    return function (event) {
        var _a, _b, _c, _d;
        const isClickOnLink = !!event.target.closest('a');
        if (!isClickOnLink) {
            (_a = event === null || event === void 0 ? void 0 : event.preventDefault) === null || _a === void 0 ? void 0 : _a.call(event);
        }
        (_b = event === null || event === void 0 ? void 0 : event.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(event);
        (_d = (_c = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _c === void 0 ? void 0 : _c.stopImmediatePropagation) === null || _d === void 0 ? void 0 : _d.call(_c);
        if (typeof fn === 'function')
            fn === null || fn === void 0 ? void 0 : fn(event);
    };
}
//# sourceMappingURL=useEventStopPropagation.js.map